import { DefaultTheme } from 'styled-components';

import footerLogo from '../../assets/svg/footerLogo.svg';
import signInLogo from '../../assets/svg/signInLogo.svg';

const theme: DefaultTheme = {
  assets: { footerLogo, signInLogo },
  palette: {
    // Dynamic colors coming from api/v1/branding_settings
    primary: ['#3067DB', '#EBF8FF', '#6299F4', '#EBF8FF'],
    secondary: ['#43BEEF', '#ADF1FF'],
    // Static colors
    background: [
      '#f9f9f9', // 0: backgroundBrand
      '#eeeeee', // 1: backgroundBrand2
      '#fdf9f6',
    ],
    calendar: [
      '#690', // 0:
      '#a67f59', // 1:
      '#07a', // 2:
      '#dd4a68', // 3:
      '#e90', // 4:
    ],
    chart: ['#5699EE'],
    warning: [
      '#ff7545', // 0: orange
      '#ffa481', // 1: orange1
      '#ffdcc0', // 2: orange2
      '#ffd952', // 3: yellow
      '#fff2bd', // 4: yellow2
      '#fff7d7', // 5: yellow3
      '#faeee4', // 6: yellow4
    ],
    success: [
      '#76cc81', // 0: green
      '#a9f0b2', // 1: green2
      '#d8ffdd', // 2: green3
    ],
    error: [
      '#ff4c4d', // 0: red
      '#ff8f8f', // 1: red2
      '#ffdbdb', // 2: red3
      '#f63839', // 3: red4
      '#da2627', // 4: red5
    ],
    border: [
      '#eeeeee', // 0: grey2
      '#e5e5e5', // 1s
      '#e1e2ed',
    ],
    info: [
      '#5699ee', // 0: infoBlue:
    ],
    grayscale: [
      '#221f20', // 0: black
      '#908f8f', // 1: grey
      '#bcbbbc', // 2: grey2
      '#eeeeee', // 3: grey3
      '#f9f9f9', // 4: grey4
      '#ffffff', // 5: white
      '#e4e4e4', // 6
      '#666', // 7
      '#FAFAFA', // 8: grey5
      '#F5F5F5', // 9: grey6,
      '#707070', // 10: grey7
      '#f8f6f6', // 11: app canvas
    ],
    text: [
      '#323332', // 0: Heading
      '#595959', // 1: HeadingLight
      '#979797', // 2: Text
      '#797979', // 3: TextDark
      '#6a6c6a', // 4: Heading Lighten 22%
      '#1F1F1F', // 5: TextPrimary (high emphasis)
      '#5E5E62', // 6: TextSecondary (medium emphasis)
    ],
    topbarNotification: [
      '#edf5ff', // 0
    ],
    jobIcons: [
      '#ffa481', // 0
      '#82d9d7', // 1
      '#ffd952', // 2
    ],
    flex: [
      '#7e8bbe', // 0
    ],
    toggle: ['#34c759'],
    // Override colors
    dayforce_flex_work: [
      '#fdf9f6', // input background color override
      '#faeee4', // input background hover color override
    ],
    maof: [
      '#fdf9f6', // input background color override
      '#faeee4', // input background hover color override
    ],
    invoiceStatuses: [
      '#76cc81', // 0, invoiced
      '#ffa481', // 1, on_hold
      '#bcbbbc', // 2 not_started
      '#10aeba', // 3 paid
      '#82d9d7', // 4 paid_partially
      '#ffd952', // 5 generated
      '#ffa481', // 6 pending
    ],
    jobFulFillmentColors: [
      '#908f8f', // 0: fulfilled color
      '#eeeeee', // 1: fulfilled background
      '#3c9e49', // 2: fulfilled 100 color,
      '#a9f0b2', // 3: fulfilled 100 background,
      '#eebc0a', // 4: fulfilled 75-99 color
      '#fff2bd', // 5: fulfilled 75-99 background
      '#ff7545', // 6: fulfilled 50-74 color
      '#ffdcc0', // 7: fulfilled 50-74 background
      '#ff4c4d', // 8: fulfilled 0-49 color
      '#ffdbdb', // 9: fulfilled 0-49 background
    ],
    highlightedRows: [
      '#FCE9EA', // 0 warning
      '#FDD3D7', // 1 warning hover
    ],
    disabledInput: [
      '#c8c7c7', // 0: input label,
      '#a3a2a2', // 1: input text
    ],
    statusTag: [
      '#ebebeb', // 0: default bg (--evr-surfaces-secondary-hovered)
      '#1f1f1f', // 1: default text (--evr-content-primary-highemp)
      '#fff9eb', // 2: warning bg (--evr-surfaces-status-warning-lowemp)
      '#1f1f1f', // 3: warning text (--evr-content-status-warning-lowemp)
      '#e0fffa', // 4: success bg (--evr-surfaces-status-success-lowemp)
      '#07312b', // 5: success text (--evr-content-status-success-lowemp)
      '#fff0ed', // 6: error bg (--evr-surfaces-status-error-lowemp)
      '#47160b', // 7: error text (--evr-content-status-error-lowemp)
    ],
    customButtons: [
      '#f2f2f2', // 0: Cancel button
      '#fafafa', // 1: Cancel button hover
      '#cccccc', // 2: Cancel button border
    ],
    globalSearch: [
      '#ededed', // 0:  background
      '#f9f9f9', // 1: background
      '#333', // 2: search text
      '#f2f2f2', // 3: background
      '#9ca3af', // 4: placeholder
      '#999', // 5: text
      '#979797', // 6: progress indicator color
    ],
    alert: [
      '#43BEEF', // 0: infoBlue:
    ],
  },
};

export default theme;
